import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-profile-completion-dialog',
  imports: [CommonModule, MatIconModule],
  templateUrl: './profile-completion-dialog.html',
  styleUrl: './profile-completion-dialog.scss',
})
export class ProfileCompletionDialog {
  constructor(readonly dialogRef: MatDialogRef<ProfileCompletionDialog>) {}

  close(action: 'complete-profile' | 'remind-later'): void {
    this.dialogRef.close(action);
  }
}
